export const PHOTO = "Photo";
export const ID_PROOF = "IDProof";
export const PAN_CARD = "PANCard";
export const TRANSPORTATION_TRADE_LICENSE = "TransportationTradeLicense";
export const BANK_CANCELLED_CHEQUE = "BankPassBook_CancelledCheque";
export const GST = "GST";
export const VEHICLE_INSURANCE = "VehicleInsurance";
export const VEHICLE_PUCC = "VehiclePUCC";
export const VEHICLE_NATIONAL_PERMIT = "VehicleNationalPermit";
export const FITNESS_NUMBER = "FitnessNo";
export const DRIVING_LICENSE = "DrivingLicense";
export const DRIVERAGREEMENT = "Driver_Agreement";
export const APPLICATION_ADDRESS_EVIDENCE = "ApplicantAddressEvidence";
export const BANK_STATEMENT = "BankStatement";
export const LOI_ABRPL_AGREEMENT = "LOI_ABRPLAgreement";
export const FOREST_AGREEMENT = "Forest_ABRPLAgreement";
export const MOA_REGISTRATION_CERTIFICATE = "MOA_RegistrationCertificate";
export const EXISTING_OCC = "ExistingOcc";
export const HIGHEST_QUALIFICATION = "HighestQualification";
export const ROAD_PHOTO = "RoadPhoto";
export const LAND_DOCUMENT = "LandDocument";
export const LABOUR_LICENCE = "LabourLicence";
export const VALATION_REPORT = "ValuationReport";
export const DILIGENCE_REPORT = "DiligenceReport";
export const NON_ENCUMBRANCE_CERTI = "NonEncumbranceCertificate";
export const GEOCODE_LOCATION = "GeocodeLocation";
export const LLE_TRADE_LICENSE = "LLETradeLicence";
export const REVENUE_CIRCLE = "Revenue Circle";
export const BLOCK_LIST = "Block Office";
export const REVENUE_BLOCK_DEFAULT_VALUE = 'Revenue Circle/Block Office'
export const NOT_MAPPED = 'Not Mapped'
export const MAPPED = 'Mapped'
export const HARVEST_PLAN = "Harvest_Plan"

// SubCategory Constants
export const JFMC = "JFMC";
export const INDIVIDUAL = "Individual";
export const FPO = "FPO"
export const FPC = "FPC"
export const SHG = "SHG"
export const FOREST = "Forest"
export const COOPERATIVE = "Co-operative"
export const OTHER_GOV_AGENCY = "Other Government Agency"


// !-------Array -------!
export const LAND_AREA_UNIT = ['sq ft', 'katha', 'bigha', 'acre', 'pura', 'hectare']
export const GENDER = ['Male', 'Female', 'Transgender']
export const NUMBER_OF_MONTH = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
export const GOV_ID_LIST = ['Aadhaar ID', 'Bank Passbook', 'Driving Licence', 'Voter ID']
export const GOV_ID_LIST_USER = ['Aadhaar ID', 'Bank Passbook', 'Driving Licence', 'Voter ID', 'Internal Employee ID']
export const SALUTATION = ['Mr', 'Mrs', 'Ms']
export const SOURCING = ['High', 'Medium', 'Low']
export const Stakeholder_Type = ['All', 'HIT', 'Interim Storage Operator', 'LLE', 'Transporter', 'Grower']
export const Stakeholder_Type_Mapping = ['HIT', 'Interim Storage Operator', 'LLE', 'Transporter', 'Grower']
export const GROWER_TYPE = ['FPO', 'FPC']


// !-------Date Formats -------!
export const API_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss";
export const BASIC_DATE_FORMAT = "YYYY-MM-DD";

// !-------Error Messages -------!
export const MOBILE_NO_ERROR = "Please enter 10 digit number";
export const PINCODE_NO_ERROR = "Please enter 6 digit pincode";
export const PAN_NO_ERROR = "Please enter pan number";
export const APPLICANT_ERROR = "Please enter name of applicant"
export const VALID_NAME_OF_APPLICANT_ERROR = "Please enter valid name"
export const ADDRESS_ERROR = "Please enter address"
export const CONTACT_PERSON_FIRST_NAME_ERROR = "Please enter first name of authorised contact person"
export const SEARCH_ICON_ERROR = "Please click pincode search icon"
export const PLOT_AREA_KATHA_ERROR = "Value of plot area is limited to 6 digit "
export const PLOT_AREA_REST_ERROR = "Value of plot area is limited to 6 digit"
export const EMPTY_FIELD_ERROR = "Field cannot be empty"
export const NUMBER_OF_CLUMPS_LIMIT_ERROR = "Total Number of clumps is limited to 6 digit"
export const FIELD_CANNOT_BE_ZERO_ERROR = "Value cannot be zero or empty"
export const LAND_AREA_ERROR = "Please enter land area"
export const LATITUDE_ERROR = "Please enter latitude"
export const LONGITUDE_ERROR = "Please enter longitude"
export const DATE_RANGE_ERROR = "End date should be greater than start date"
export const WEIGHT_ERROR = "Value of weight is limited to 5 digit"

// !-------Resource error Messages -------!
export const CATEGORY_ERROR = "Please select category"
export const ITEM_TYPE_ERROR = "Please select item type"
export const STATE_ERROR = "Please select state"
export const DISTRICT_ERROR = "Please select district"
export const REVENUE_CIRCLE_ERROR = "Please select revenue circle"
export const ROUTE_TYPE_ERROR = "Please select route type"
export const UNIT_PER_ERROR = "Please select unit"


// !-------API -------!
export const SAVE_EXIT_API = "SaveAndExit";
export const SUBMIT_API = "Submit";
export const ADD_POPOVER = "Add"
export const UPDATE_POPOVER = "Update"
export const CANCEL_POPOVER = "Cancel"
export const UPLOAD_FILE_TEXT = "Upload File"


// !-------LLE Pre Reg Constants -------!
export const WITHIN_25_KM = "Within 25 kms from the opted location of same district";
export const BEYOND_25_KM = "Beyond 25 kms but same district of opted location";
export const ADJACENT_DISTRICT = "From adjacent district";
export const OTHER_DISTRICT = "From any other districts of the state";

export const WITHIN_100_METER = "Within 100 meters";
export const BTWN_100_500_METER = "Between 100 to 500 meters";
export const BTWN_500_1_METER = "Between 500 meters to 1 km";

export const MORE_THAN_8_HR = "More than 8 hours";
export const BTWN_6_8_HR = "Between 6-8 hours";
export const BTWN_4_6_HR = "Between 4-6 hours"

export const LESS_THAN_2_FEET = "Less than or equal to 2 feet"
export const MORE_THAN_2_FEET = "More than 2 feet"

// !-------ISO Pre Reg Constants -------!

export const MORE_THAN_4_BIGAH = "More than 4 Bighas"
export const BTWN_3_4_BIGAH = "Between 3-4 Bighas"

// !-------API bambooSpecies Constants -------!
export const SPECIES_OTHER = '8ac9c905-3108-47fc-ba1e-9f1ee83e1a84'
export const SPECIES_2 = '2e22b029-8c51-4f6a-af56-19523a565532'
export const SPECIES_1 = 'd9c75da2-b03d-464e-accd-240eed41a4da'


// !-------Shortlist, Waitlist Constants -------!
export const SHORTLIST = 'Shortlisted'
export const WAITLIST = 'Waitlisted'

// !-------OTP Validation -------!
export const OTP_SENT_MESSAGE = "Please enter the OTP sent to your mobile number";
export const INVALID_OTP_ERROR = "Invalid OTP";

export const CONSTANTS = {
     ID_PROOF_ARRAY : ['MOA', 'Registration Certificate','GST','Other'],
     GOV_ID_LIST : [ 'Aadhaar ID', 'Voter ID', 'Driving Licence', 'Bank Passbook']

}
export const MESSAGES = {
    PRE_REG_SUCCESS: "Pre-registration intimations sent successfully"
}



// !-------Rate Card Constants -------!
export const CREATE_RATE_CARD = "Create Rate Card"
export const EDIT_RATE_CARD = "Edit Rate Card"
export const VERIFY_RATE_CARD_DETAILS = "Verify Rate Card"
export const CATEGORY = "Category"
export const ITEM_TYPE = "Item Type"
export const ROUTE_TYPE = "Route Type"
export const STATE = "State"
export const DISTRICT = "District"
// export const REVENUE_CIRCLE = "Revenue Circle"
export const UNIT_PER = "Unit"
export const ITEM_RATE_MASS_ENTRY = "Item Rate(Mass Entry)"
export const STAKEHOLDER_URN = "StakeHolder URN"
export const STAKEHOLDER_NAME = "StakeHolder Name"
export const REGISTRATION_NO = "Registration No"
export const VEHICLE_TYPE = "Vehicle Type"
export const VEHICLE_CAPACITY = "Vehicle Capacity"
export const VEHICLE_MAKE = "Vehicle Make"
export const VEHICLE_MODEL = "Vehicle Model"
export const ROUTE = "Route"
export const LAND_NAME = "Land Name"
export const ITEM_RATE = "Item Rate(in INR)"
export const SUBMIT = "Submit"
export const NEXT = "Next"
export const INSERT_ALL = "+Insert All"
export const INSERT_SELECTED = "+Insert Selected"
export const VIEW_OR_EDIT_RATE_CARD = "View Approved Rates"
export const NO_DATA_AVAILABLE = "No Data Available"
export const PROCEED = "Proceed"
export const VERIFY_RATE_CARD = "Verify Rate Card"
export const LLE = "LLE"
export const STAKEHOLDERTYPE = {
    ALL: "ALL",
    HIT: "HIT",
    Transporter: "Transporter",
    LLE: "LLE",
    Grower: "Grower",
    InterimStorageOperator: 'Interim Storage Operator',
}
export const STAKEHOLDERSUBTYPE = {
    GROWER: "Grower",
    JFMC: "JFMC",
    INDIVIDUAL: "Individual",
    FPO: "FPO",
    FPC: "FPC",
    SHG: "SHG",
    FOREST: "Forest",
    COOPERATIVE: "Co-operative",
    OTHER_GOV_AGENCY: "Other Agency",
}
export const ROLES = {
    ItAdmin: "Reg-ITAdmin",
    RegistrationScruitnizer: "Reg-Scrutinizer",
    LeadRegScrutinizer: "Reg-LeadScrutinizer",
    RegInCharge: "Reg-Incharge",
    RegAssistant: "Reg-Assistant",
    RegSCMUser: "Reg-Scmuser",
    RegSuperVisor: "Reg-Supervisor",
    StakeHolder: "Reg-Stakeholders",
    SCMInCharge:"SCM-InCharge",
    UserOnboarding:"Reg-UserAdmin",
}

export const RESOURCE_ROLES = {
    PlantSCMMember: "Res-Scmuser",
    ModuleIncharge: "Res-Incharge",
    ResourceScrutinizer: "Res-Scrutinizer",
    CommercialUser: "Res-Commercial",
    FinanceUser: "Res-Finance",
    Approver: "Res-Approver",
    StakeHolder: "Res-Stakeholders",
    SuperAdmin: "Super Admin",
    Admin: "Admin",
    ResSupervisor: "Res-Supervisor",
    ResPlantationManager: "Res-PlantationManager"
}

export const HELPDESK_ROLES = {
    // HelpdeskTeamMember:"Helpdesk Team Member",
    HelpdeskSupportExecutive: "GHD-SupportExecutive",
    HelpdeskAssistant: "GHD-HelpdeskAssistant",
    HelpdeskAdminUser: "GHD-Incharge",
    SMUSer: "GHD-Scmuser",
    StakeHolder: "Stake Holder",
    Admin: "GHD-Stakeholders",
    GuestUser: "GHD-GuestUser",
    ExternalAdminUser: "GHD-ExtAdminUser",
    ExternalSupportExecutive: "GHD-ExtSupportExecutive"
}
export const PIT_ROLES = {
    ABRPLSCMEndUser:"ABRPL SCM End User",
    Admin:"Admin",
    LLE: "LLE",
    Grower: "Grower",
    HIT: "HIT",
    Transporter: "Transporter",
    InterimStorageOperator: "Interim Storage Operator",
    ProcurementLead: "PIT-Commercial",
    PitApprover: "PIT-CommercialApprover",
    PitScmUser: "PIT-Scmuser",
    TransportationIncharge: "PIT-Logistics",
    ProcessingIncharge: "PIT-Processing",
    PitUnloader: "PIT-Unloader",
    PitWeighbridgeOperator: "PIT-WeighbridgeOperator",
    FinanceUser: "Res-Finance",
    Loader:"PIT-Loader",
    Incharge: "PIT-Incharge",
    PlantSCMOperator: "PIT-PlantSCMOperator",
    PitManualWeighbridgeOperator: "PIT-ManualWeighbridgeOperator",
    PitProcessingPlant: "PIT-ProcessingPlant",
    LLESCMOperator: "PIT-LLESCMOperator",
    PitProcessingLLE: "PIT-ProcessingLLE"
}

export const QUALITY_ROLES = {
    QualityModuleIncharge: "Qty-Incharge",
    Inspector: "Qty-Inspectors",
    Admin: "Admin",
    ScmUser: "Qty-Scmuser",
    Processing: "Qty-Processing",
    StakeHolder: "Qty-Stakeholders"
}

export const DEMAND_ROLES = {
    DemandPlanner: "Dmd-Scmuser",
    DemandModuleIncharge: "Dmd-Incharge",
    ProcessingIncharge: "PIT-Processing",
    ProcurementLead: "PIT-Commercial",
    StakeHolder: "Dmd-Stakeholders"
}

export const PAYMENT_ROLES = {
    SCMEndUser: "Pymt-Scmuser",
    PaymentApprover: "Pymt-Approver",
    FinanceUser: "Pymt-Financeuser",
    StakeHolder: "Pymt-Stakeholders",
    Updater: "Pymt-Updater",
    PaymentViewer: 'Pymt-Viewer'
}

export const DEMAND_CONSTANTS = {
    NoDataMessage: "No Data Available",
    NoDataUpdated: "No Data Updated",
    ADVANCEPAYMENT: "Advance Payment",
    ROYALTYPAYMENT: "Royalty Payment",
    INVOICE: "Regular",
    MONTHLY: "Monthly",
    TWODAYS: "48 Hours",
    FORTNIGHTLY: "Fortnightly"

}

export const PAYMENT_CONSTANTS = {
    paymentUnderProcess: "Payment_Under_Process",
    paid: "Paid"
}

export const UPDATE_PAYMENT_PROCESS_STATUS = "/updatePaymentProcessStatus";

export const MODULE_ACCESS = {
    PIT: false,
    DEMAND: false,
    QUALITY: true,
    PAYMENT: true,
    HELPDESK: true,
    RESOURCE: true,
    REGISTRATION: true,
}

export const allowedPhotoTypes = ["image/png", "image/jpg", "image/jpeg"];

export const PROD = true

export const TITLE = "ABEPL Digital Bamboo Supply Chain Platform"

export const BAMBOO_FARMERS_TITLE = "Bamboo farmers"
export const HIT_TITLE = "Harvesting cum Interim Transporters (HITs)"
export const LLE_TITLE = "Local Level Entrepreneurs (LLEs)"
export const TRANSPORTER_TITLE = "Transporters"

export const BAMBOO_FARMERS_CONTENT = "They are the owners of the existing bamboo growing stock who can directly supply the bamboo to ABEPL and receive e-payments in their registered bank accounts corresponding to the quantum of bamboo supplied as per the prevalent rates at the time of supply"
export const HIT_CONTENT = "They are responsible for the sustainable harvesting, de-limbing, sizing, bundling, and weighing of bamboo at the farmers location and transporting to the nearest bamboo aggregation cum processing center"
export const LLE_CONTENT = "They are responsible for owning and operating the aggregation cum processing centers, where the bamboo received from HITs would be stored suitably and converted into desired bamboo chips size and quality"
export const TRANSPORTER_CONTENT = "They are responsible for transporting the bamboo chips from different LLE locations to ABEPL premises for further processing"

export const NEWS = [
    "MOU with Chroma Biotech LLP for sourcing tissue cultured bamboo saplings",
    "MOU signed with Ampri Farmer Producer Company, Sonapur for bamboo sourcing",
    "Letter Of Intent awarded to 8 LLEs",
    // "Bamboo registration done for 330 acres in AOSENDEN village, Mokokchung District of  Nagaland in Dec 2024",
    "Bamboo farmer registration presently underway"
]
export const NEWS_CONTENT = [
    "টিছু কালচাৰ কৰা বাঁহৰ পুলি ৰখাৰ বাবে ক্ৰোমা বায়োটেক এলএলপিৰ সৈতে বুজাবুজি চুক্তি",
    "বাঁহৰ উৎসৰ বাবে সোনাপুৰৰ আমপ্ৰী ফাৰ্মাৰ প্ৰযোজক কোম্পানীৰ সৈতে বুজাবুজি চুক্তি স্বাক্ষৰিত হৈছে",
    "৮ টা এল এল ইক প্ৰদান কৰা হৈছে অভিপ্ৰায় পত্ৰ",
    // "২০২৪ চনৰ ডিচেম্বৰ মাহত নাগালেণ্ডৰ মককচুং জিলাৰ আওচেণ্ডেন গাঁৱত ৩৩০ একৰ মাটিৰ বাবে বাঁহৰ পঞ্জীয়ন কৰা হয়।",
    "বাঁহ খেতিয়কৰ পঞ্জীয়ন বৰ্তমান চলি আছে"
]

export const ABOUT_US = [
    "Assam Bio Ethanol Private Limited (ABEPL) is the first bio refinery to produce fuel grade ethanol from bamboo biomass. ABEPL had been registered on 04.06.2018 as a joint venture company between Numaligarh Refinery Limited (NRL) and two Finnish companies Fortum BV and Chempolis Oy. The refinery premises are located at Numaligarh in the Golaghat district of Assam. The refinery has an annual rated production capacity of 48900 MT of ethanol, 19000 MT of furfural, 11000 MT of acetic acid, and 31000 MT of food grade liquid CO2.",
    "ABEPL is driven by economic, social, and environmental objectives in the form of upliftment of rural economy through additional income for bamboo farmers, employment generation for skilled harvesters, entrepreneurship setups, and reduction of GHG emissions.",
    "Bamboo is the primary feedstock for the refinery with an annual consumption capacity to the extent of 500 TMT green bamboo (300 TMT dry bamboo equivalent), which will be sourced from identified bamboo growing regions within the economic catchment zone. ABEPL has conceptualized and developed a unique and ambitious supply chain model to source bamboo directly from individual bamboo farmers as well as bamboo farmers groups. Accordingly, there are decentralized aggregation and processing centers identified at strategic locations spread across the sourcing zone of ABEPL, where the harvested bamboo from farmers within a specified vicinity will be received. These centers would also be responsible for converting the pole bamboo into desired bamboo chips of approx. 1 square inch size. The bamboo chips so produced would then be transported to the refinery for further processing to produce bioethanol and other products.",
    "ABEPL is not just committed towards inclusive growth of all stakeholders involved in the supply chain, but takes responsibility for the replenishment of the bamboo being harvested in the form of facilitating - plantation activities through different govt. bodies, credit linkages for farmers, and availability of quality planting materials in the form of tissue cultured saplings, etc. ABEPL, thus intends to create an end-to-end sustainable supply chain eco system where people, environment, and economy flourishes in an equitable manner."
]

export const allowedFileTypes = ["image/png", "image/jpg", "image/jpeg", "application/pdf"];
export const demandAllowedFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.oasis.opendocument.spreadsheet"]
export const FILE_NAME_VALIDATION_ERROR = "A File name cannot contain any of the following charcater: \"\$%*/\:?<>|"

export const bundleArr = [{
    code: "BUN",
    name: "Bundle ID"
},
{
    code: "CON",
    name: "Consignment No"
},
{
    code: "H-C",
    name: "Heap No"
}]

export const SQMT_TO_BIGHA_CONVERSION_FACTOR = 0.0003
export const AREA_REQUIRED_FOR_ONE_CLUMP = 0.0186873273758134

export const PLANT_URN = "ABEPL"

export const LINKS = {
    PRIVACY_POLICY: "https://abepl.co.in/Document/Policy/privacy-policy.html",
    TERMS_OF_USE: "https://abepl.co.in/Document/Policy/terms-of-use.html"
}